/*
 *
 * StoriesDestinationPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'storiesDestinationPage';
export const initialState = {
    is404: false,
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: {
            items: [],
            pager: '',
            hasMore: true,
        },
    },
    params: {
        slug: '',
        state: '',
    },
};

/* eslint-disable no-param-reassign, default-case */
function storiesDestinationPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_PARAMS:
                draft.params = action.params;
                return draft;
            case ActionTypes.SET_IS_404:
                draft.is404 = action.is404;
                return draft;
            case ActionTypes.RESET_CONTENTS:
                draft.is404 = initialState.is404;
                draft.page = initialState.page;
                return draft;
            // Page
            case ActionTypes.RESET_PAGE:
                draft.page.res = initialState.page.res;
                return draft;
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            default:
                return draft;
        }
    });
}

export default storiesDestinationPageReducer;
